import React from 'react'
import { formatNumber, isDotNetLongCompatible } from '@/utils/numberUtilities'

const style = { float: 'right' }
function IntegerRenderer ({ value }) {
  const formatted = isDotNetLongCompatible(value) ? formatNumber(value) : ''
  return <span style={style}>{formatted}</span>
}

export { IntegerRenderer }



// WEBPACK FOOTER //
// ./src/components/report-tables/renderers/integerRenderer.js